import RoomComponent from './Room';
export default RoomComponent;
